export default {
	data() {
		return {
			resizingColumn: false,
			resizeMousemoveListener: null,
			resizeMouseupListener: null,
		};
	},
	methods: {
		_startResizeColumn(columnStartX, column) {
			let originalWidth = column.width;
			this.resizingColumn = true;
			let newWidth = originalWidth;

			this.resizeMouseupListener = (e) => {
				e.preventDefault();
				e.stopPropagation();
				this._removeEventListeners();
				setTimeout(() => this.resizingColumn = false, 100);

				if (newWidth !== originalWidth) {
					/**
					 * When columns are resized. Payload is column name and new width.
					 * @event column-resized
					 * @type {object}
					 */
					column.width = newWidth;
					this.$emit('column-resized', { name: column.field, width: column.width });
					this._storeLocalColumns();
				}
			};
			this.resizeMousemoveListener = (e) => {
				e.preventDefault();
				e.stopPropagation();

				if ((e.buttons & 1) === 0) {
					this._removeEventListeners();
					return;
				}

				newWidth = e.pageX - columnStartX;
				let minWidth = column.minWidth ? column.minWidth : 10;
				newWidth = Math.ceil(Math.max(minWidth, newWidth));
				//console.log(newWidth, columnStartX + newWidth, e.pageX);
				this.$refs.resizePreview.style.left = `${Math.max(e.pageX, columnStartX + minWidth - 5) - 500}px`;
			};
			window.addEventListener('mouseup', this.resizeMouseupListener);
			window.addEventListener('mousemove', this.resizeMousemoveListener);
		},
		_removeEventListeners() {
			if (this.resizeMousemoveListener) {
				window.removeEventListener('mousemove', this.resizeMousemoveListener);
				this.resizeMousemoveListener = null;
			}
			if (this.resizeMouseupListener) {
				window.removeEventListener('mouseup', this.resizeMouseupListener);
				this.resizeMouseupListener = null;
			}
		},
	},
	destroyed() {
		this._removeEventListeners();
	},
};